<template>
    <AdminNextIframe
        path="/collections/new"
        :query="{ clientId: $route.params.id }"
        @navigate="onNavigate"
        @back="onBack" />
</template>

<script>
import AdminNextIframe from '@/components/ui/iframe/AdminNextIframe';

export default {
    name: 'ClientCollectionsCreateIframe',
    components: { AdminNextIframe },
    methods: {
        // next-admin posts `navigate` on every one of its own route changes, so
        // only act on the pages that are still legacy. Create and the article
        // selector live inside the iframe and must stay there.
        onNavigate(path) {
            const detail = path.match(/^\/collections\/([^/]+)\/?$/);
            if (!detail) return;

            const segment = detail[1];
            if (segment === 'new' || segment === 'select-articles') return;

            this.$router.push({
                name: 'client-collections-details',
                params: { id: this.$route.params.id, collectionID: segment }
            }).catch(() => {});
        },
        onBack() {
            this.$router.push({
                name: 'client-collections',
                params: { id: this.$route.params.id }
            });
        }
    }
}
</script>
